import { useVideoCallContext, type VideoCallContextValue } from "../contexts/VideoCallContext";

export type { VideoCallStatus } from "../contexts/VideoCallContext";

/**
 * An alias, not a copy. This used to restate every field of the context by
 * hand, which meant the shim silently went out of date whenever the context
 * gained or lost one.
 */
export type UseVideoCallReturn = VideoCallContextValue;

/**
 * Backward-compatible hook that delegates to VideoCallContext.
 * Pages that previously called useVideoCall() directly continue to work
 * with no changes other than ensuring they are wrapped in VideoCallProvider.
 */
export function useVideoCall(): UseVideoCallReturn {
  return useVideoCallContext();
}
